// This file was automatically generated from appshared.dialog.imagesZoom.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.imagesZoom');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.imagesZoom.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.images.length > 0) {
    output.append('<ul>');
    var imageList8107 = opt_data.images;
    var imageListLen8107 = imageList8107.length;
    for (var imageIndex8107 = 0; imageIndex8107 < imageListLen8107; imageIndex8107++) {
      var imageData8107 = imageList8107[imageIndex8107];
      el8.template.appshared.dialog.imagesZoom.image({image: imageData8107}, output);
    }
    output.append('</ul>');
  } else {
    output.append('<div>There are no images to display.</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.imagesZoom.imageFeed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul id="zoomed-images-feed-list" class="results"></ul><div class="el8PageFeedContainer"><button type="button" id="zoomed-images-more-btn" class="el8SectionButton">More</button></div><input type="text" name="esc" style="width:1px" />');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.imagesZoom.image = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li><div class="image-item-wrap el8ImagePreviewItem"><div data-src="', soy.$$escapeHtml(opt_data.image), '" class="image-item imageLoading" data-id="', soy.$$escapeHtml(opt_data.image), '"></div></div></li>');
  if (!opt_sb) return output.toString();
};
